import { render, staticRenderFns } from "./ServiceAddItem.vue?vue&type=template&id=bbb0ef44&scoped=true&"
import script from "./ServiceAddItem.vue?vue&type=script&lang=js&"
export * from "./ServiceAddItem.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAddItem.vue?vue&type=style&index=0&id=bbb0ef44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb0ef44",
  null
  
)

export default component.exports